import { RoutesList } from "@routes/Routes";
import { useLocation } from "react-router-dom";

export const GovMetricSidebar = () => {
  const location = useLocation();
  const isConfirmationPage = location.pathname.includes(
    RoutesList.CONFIRMATION,
  );

  const govMetricSnippet = (
    <>
      <div className="gm_sidebar gm_sidebar_rh z-0">
        <a
          href="https://websurveys2.govmetric.com/theme/gm/9990078"
          className="gm_sidebar_anchor"
          role="button"
          rel="nofollow"
        >
          <img
            src="https://websurveys2.govmetric.com/imgs/triggers/rh.svg"
            alt="Feedback button"
          />
        </a>
      </div>{" "}
    </>
  );

  return isConfirmationPage ? govMetricSnippet : null;
};
